export default "__VITE_ASSET__HJZkKmMD__";